import src from "IMAGE";
export default { src, width: 1024, height: 212, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAN0lEQVR42i3KoQkAIBRF0b+WzQEsglhEEKPgAM5gdt7nDT+cdkxSxMNBQ8VARjAPFxsFHQsT6QP/rzW7wg0m6gAAAABJRU5ErkJggg=="};
